import { createFileRoute, redirect } from '@tanstack/react-router'
import { QuoteWorkflowShell } from '@/features/quote-builder/workflow/quote-workflow-shell'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId/workflow/$stage')({
  // Pricing became part of Equipment (USA-1140); older links and bookmarks land there.
  beforeLoad: ({ params }) => {
    if (params.stage === 'pricing') {
      throw redirect({ to: '/quotes/$quoteId/workflow/$stage', params: { ...params, stage: 'equipment' }, replace: true })
    }
  },
  component: QuoteWorkflowRoute,
})

function QuoteWorkflowRoute() {
  const { quoteId, stage } = Route.useParams()
  return <QuoteWorkflowShell quoteId={quoteId} stageKey={stage} />
}
